import { GtmTracker } from '@/modules/common/services/analytics';
import { Categories } from '@/types/models/Analytics';

const trackEventIndication = GtmTracker.trackerWithDefaultProps({
  page_screen: 'indication_modal',
  digital_experience: 'investor',
  experience_section: Categories.Indication
});

const trackEventLinkCopied = GtmTracker.trackerWithDefaultProps({
  page_screen: 'link_copied_modal',
  digital_experience: 'investor',
  experience_section: Categories.Indication
});

export function trackViewLoadIndication() {
  trackEventIndication({
    event_type: 'load',
    event_name: 'view'
  });
}

export function trackClickSendInvite() {
  trackEventIndication({
    event_type: 'click',
    event_name: 'send_invite_modal'
  });
}

export function trackViewLoadLinkCopied() {
  trackEventLinkCopied({
    event_type: 'load',
    event_name: 'view'
  });
}
